import { AxiosResponse } from 'axios'
import { HttpService } from './common/HttpService'
import { ContactGroupResponseDTO } from '@/models/dto/contact/ContactGroupResponseDTO'
import { AddContactResponseDTO } from '@/models/dto/contact/AddContactResponseDTO'
import { UpdateContactResponseDTO } from '@/models/dto/contact/UpdateContactResponseDTO'
import { DeleteContactResponseDTO } from '@/models/dto/contact/DeleteContactResponseDTO'
import { AddContactRequestDTO } from '@/models/dto/contact/AddContactRequestDTO'
import { UpdateContactRequestDTO } from '@/models/dto/contact/UpdateContactRequestDTO'
import { ContactResponseDTO } from '@/models/dto/contact/ContactResponseDTO'

const httpService: HttpService = new HttpService()
export default {
  getContacts(reservationId: number): Promise<AxiosResponse<ContactGroupResponseDTO>> {
    const url = `/charterup/v1/reservation-details/${reservationId}/contacts`
    return httpService.get<ContactGroupResponseDTO, void>(url)
  },
  addContact(reservationId: number, payload: AddContactRequestDTO): Promise<AxiosResponse<AddContactResponseDTO>> {
    const url = `/charterup/v1/reservation-details/${reservationId}/contacts`
    return httpService.post(url, payload)
  },
  updateContact(reservationId: number, userExternalId: string, payload: UpdateContactRequestDTO): Promise<AxiosResponse<UpdateContactResponseDTO>> {
    const url = `/charterup/v1/reservation-details/${reservationId}/contacts/${userExternalId}`
    return httpService.patch(url, payload)
  },
  deleteContact(reservationId: number, userExternalId: string): Promise<AxiosResponse<DeleteContactResponseDTO>> {
    const url = `/charterup/v1/reservation-details/${reservationId}/contacts/${userExternalId}`
    return httpService.delete(url)
  },
  getContact(reservationId: number, userExternalId: string): Promise<AxiosResponse<ContactResponseDTO>> {
    const url = `/charterup/v1/reservation-details/${reservationId}/contacts/${userExternalId}`
    return httpService.get(url)
  }
}
